<template>
  <div class="page-home">
    <BannerSwiper />

    <HomeInsurance />
    <HomeNews />

    <PartnerLogos />
    <ContactSection />
  </div>
</template>

<script>
import BannerSwiper from '@/components/BannerSwiper.vue'
import PartnerLogos from '@/components/PartnerLogos.vue'
import ContactSection from '@/components/ContactSection.vue'
import HomeNews from '@/components/HomeNews.vue'
import HomeInsurance from '@/components/HomeInsurance.vue'

export default {
  name: 'HomePage',
  components: {
    BannerSwiper,
    PartnerLogos,
    ContactSection,
    HomeNews,
    HomeInsurance
  }
}
</script>

<style scoped>
.page-home {
  background: #f8fafc;
}
</style>
